import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ChecklistDisplayItem, ChecklistItemDecision } from '@core/models';
import { OptionalNoteFieldComponent } from '../optional-note-field/optional-note-field.component';

@Component({
  selector: 'app-checklist-category-step',
  imports: [CommonModule, FormsModule, OptionalNoteFieldComponent],
  templateUrl: './checklist-category-step.component.html',
  styleUrl: './checklist-category-step.component.scss',
})
export class ChecklistCategoryStepComponent {
  @Input({ required: true }) categoryName = '';
  @Input({ required: true }) items: ChecklistDisplayItem[] = [];
  @Input({ required: true }) decisions: Record<string, ChecklistItemDecision> = {};

  @Output() decisionChange = new EventEmitter<{
    itemId: string;
    patch: Partial<ChecklistItemDecision>;
  }>();

  get isWearCategory(): boolean {
    return this.categoryName.toLowerCase().includes('freno');
  }

  setStatus(itemId: string, status: 'OK' | 'FAIL'): void {
    this.decisionChange.emit({ itemId, patch: { status, doesNotApply: false } });
  }

  setNotApply(itemId: string): void {
    const isCurrentlyNotApply = this.decisions[itemId]?.doesNotApply ?? false;
    this.decisionChange.emit({
      itemId,
      patch: { status: null, wearPercent: null, doesNotApply: !isCurrentlyNotApply },
    });
  }

  onWearInput(itemId: string, event: Event): void {
    const value = Number((event.target as HTMLInputElement | null)?.value ?? '');
    const wearPercent = Number.isFinite(value) ? Math.min(100, Math.max(0, value)) : null;
    this.decisionChange.emit({ itemId, patch: { wearPercent, doesNotApply: false } });
  }

  onNotesChange(itemId: string, value: string): void {
    this.decisionChange.emit({ itemId, patch: { notes: value } });
  }
}
